import rnLocalStorage from 'rhino/src/components/local-storage/local-storage.module';
import rnSession from 'rhino/src/components/session/session.module';

import * as rnLocalPreferences from './local-prefs.constant';
import * as rnPreferences from './preferences.service';

export default angular.module('rhino.components.preferences', [rnSession, rnLocalStorage])
  .constant(rnLocalPreferences.name, rnLocalPreferences.default)
  .factory(rnPreferences.name, rnPreferences.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/preferences/preferences.module.js